export default __webpack_public_path__ + "static/media/ticketimprimir.19f7e224.svg";